import React, { Component, ReactNode } from 'react';
import DoubleHeader from 'components/DoubleHeader';
import IconArrowRight from 'components/IconArrowRight';
import IconHanger from 'components/IconHanger';
import Layout1x1 from 'components/Layout1x1';
import Layout2x1ImageLeft from 'components/Layout2x1ImageLeft';
import NextSteps from 'components/NextSteps';
import Picture from 'components/Picture';
import SalesCalloutInspiration from 'components/SalesCalloutInspiration';
import SalesCalloutSwatches from 'components/SalesCalloutSwatches';
import Line from '../../src/components/Line';
import { withPageStaticProps } from 'utils/header';

interface CardInterface {
  cardHeader: string;
}

type CardProps = React.FC<React.HTMLAttributes<HTMLDivElement> & CardInterface>;

const Card: CardProps = ({ className = '', cardHeader }) => {
  return (
    <>
      <div className={`${className} col-span-5 xs:col-span-4 sm:col-span-3 lg:col-span-2 `}>
        <div className="bg-white">
          <picture>
            <source srcSet="https://gentux.imgix.net/1560437572_menguin-sales-callout-hto.jpg" />
            <img
              alt="Menguin shipping box"
              src="https://gentux.imgix.net/1560437572_menguin-sales-callout-hto.jpg"
              loading="lazy"
              style={{ aspectRatio: '276 / 197' }}
            />
          </picture>
          <div className={`mt-64 flex items-center justify-between px-16 py-8 ${cardHeader === 'Free' ? 'border-b-2' : ''} border-blue`}>
            {cardHeader === 'Free' ? <h3 className="text-h3">{cardHeader}</h3> : <h3 className="text-h3 text-gray">{cardHeader}</h3>}

            <IconHanger className="text-gray" />
          </div>
        </div>
      </div>
    </>
  );
};

interface StepsInterface {
  stepsHeader?: string;
  stepsMainContent?: ReactNode;
}

type StepsProps = React.FC<React.HTMLAttributes<HTMLDivElement> & StepsInterface>;

const Steps: StepsProps = ({ className = '', stepsHeader, stepsMainContent }) => {
  return (
    <>
      <div className={`${className} col-span-6 md:col-span-4`}>
        <div className={`inline-block ${stepsHeader ? 'border-t' : ''} border-gray pr-24 pt-8`}>
          <h3 className="text-h2 text-gray-darker">{stepsHeader}</h3>
        </div>
        {stepsMainContent}
      </div>
    </>
  );
};

class GroomsFree extends Component {
  render() {
    return (
      <>
        <div className="bg-white">
          <Layout2x1ImageLeft
            className="p-section pb-64"
            image={<DoubleHeader hero smallTitle={<h1>Free Rental</h1>} largeTitle={<h2>This one’s for you, on the&nbsp;house.</h2>} />}
          >
            <p className="mt-32">
              With 5 paid rentals, the groom or wedding couple qualifies for a free suit or tux rental. Wedding party members, best men,
              fathers, ring bearers or wedding guests—if it adds up to five, the sixth one is free.
            </p>
            <a
              id="cta-button-hero-quality-rentals"
              className="btn-info tracker-cta-free_groom_rental-hero-20190709-100415 btn inline-flex items-center space-x-8"
              href="http://menguin.com/l/YEEB0G"
            >
              Build a Look
              <IconArrowRight />
            </a>
          </Layout2x1ImageLeft>

          <div className="row container">
            <div className="col-start-1 col-end-13 sm:col-start-5">
              <Picture
                hero
                url="https://gentux.imgix.net/1638581307_MGSiteGroomsRentFreeGrooms.jpg"
                alt="Groom and groomsmen in black tuxedos with backdrop of palm trees and high rises"
              />
            </div>
          </div>
          <div className="-mt-64 bg-gray-lighter pt-64" />
        </div>

        <div className="bg-gray-lighter py-1">
          <Layout1x1 className="m-section">
            <div className="space-y-32">
              <img
                loading="lazy"
                src={`https://gentux.imgix.net/1638581456_MGSiteGroomsRentFreeBox.jpg`}
                alt="Menguin box in home office."
              />

              <h2 className="text-h2">How To Get Your Free Rental</h2>

              <p>Follow these easy steps to get a free rental for the groom or wedding couple.</p>

              <Line />

              <ol>
                <li>
                  <p>Set up a free account</p>
                </li>
                <li>
                  <p>Create your looks</p>
                </li>
                <li>
                  <p>
                    Invite at least 5 paying members <small className="text-sm">(minimum rental of jacket and pants)</small>
                  </p>
                </li>
              </ol>
              <h3 className="text-h4-display">
                Once all members have been invited and paid, use the promo code MYFREESUIT at checkout and you are all set.
              </h3>
              <p className="col-start-2 col-end-13 text-xs md:col-start-3">
                *Free Rental: Applies to wedding events only. A jacket and pants are required for the free rental promotion. With five paid
                rentals (jacket and pants minimum), the wedding couple will receive one suit or tuxedo rental for free. Discounts cannot be
                applied to rush fees, taxes, or alterations. Discount offers may not be combined with other offers or be redeemed for cash
                or credit. Limit one per event. Promo Code: MYFREESUIT. Discount expires 12/31/2026.
              </p>
            </div>
          </Layout1x1>
        </div>

        <NextSteps
          ctaPageName="free_groom_rental"
          salesCallout1={<SalesCalloutInspiration ctaPageName="free_groom_rental" />}
          salesCallout2={<SalesCalloutSwatches ctaPageName="free_groom_rental" />}
        />
      </>
    );
  }
}

export const getStaticProps = withPageStaticProps();

export default GroomsFree;
